<template>
  <div class="exam_con">
    <h2 class="exam_con_t">当前考试信息</h2>
    <div class="exam_bd">
      <ul>
        <span v-for="exam in examList" :key="exam.examUserId">
          <li v-if="exam.allowWeb === 1">
            <span class="ks_conL"><img src="@/assets/images/tb.png"/></span>
            <div class="ks_conC">
              <h1 class="ks_tit">{{ exam.examName }}</h1>
              <p class="id_nr">
                {{ exam.oneWord }}&nbsp;&nbsp; &nbsp;&nbsp;时间：
                <span v-html="changeFormat(exam.startDate, exam.endDate)" />
              </p>
            </div>
            <div class="ks_conR">
              <a
                v-if="exam.state === 1"
                @click="
                  joinExam(
                    exam.state,
                    exam.examUserId,
                    exam.allowWeb,
                    exam.startDate
                  )
                "
                class="cjks_btn"
                >参加考试</a
              >
              <a
                v-if="exam.state === 2"
                @click="
                  joinExam(
                    exam.state,
                    exam.examUserId,
                    exam.allowWeb,
                    exam.startDate,
                    exam.allowResume
                  )
                "
                class="cjks_btn"
                >恢复考试</a
              >
            </div>
          </li>
        </span>
      </ul>
      <ul style="display:none">
        <li style="border: 0px solid #eee;">
          <div class="ks_conR">
            <a class="cjks_btn" href="javascript:void(0);" @click="checkVideo()"
              >检测摄像头</a
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getExamList, getServerTime } from "@/api/login";
export default {
  name: "CurExam",
  data() {
    return {
      tokenBean: {
        token: ""
      },
      examList: [],
      stateList: [
        { key: 1, name: "未考试" },
        { key: 2, name: "考试中" },
        { key: 3, name: "已考试" }
      ],
      loading: false,
      redirect: undefined,
      serverTime: ""
    };
  },
  created() {
    //console.log("token=" + this.token);
    // alert(this.token);
    if (this.token === "") {
      this.$router.push("/login");
    } else {
      this.initData();
    }
  },
  computed: {
    token() {
      return this.getToken();
    }
  },
  methods: {
    initData() {
      getServerTime().then(res => {
        if (res.code === 200) {
          this.serverTime = res.data.dateTime;
        }
      });
      this.tokenBean.token = this.token;
      getExamList(this.tokenBean).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.examList = res.data;
        } else {
          // this.$message.error(res.data.message);
          this.$router.push("/login");
        }
      });
    },
    notice(str) {
      alert(str);
    },
    joinExam(state, id, allowWeb, startDate, allowResume) {
      const isIE = window.ActiveXObject || "ActiveXObject" in window;
      if (isIE) {
        alert(
          "温馨提示，本考试系统不支持IE浏览器，请更换到其它浏览器\n给您带来不便，敬请谅解"
        );
        return;
      }
      const sdate = Date.parse(startDate); // 开始考试时间
      const cdate = Date.parse(this.serverTime); //当前时间
      if (sdate - cdate > 0) {
        alert("考试未开始");
        return;
      }
      if (state === 3) {
        this.$message.error("您已经参加了该试卷的考试。");
        return;
      }
      if (allowWeb === 0) {
        this.$message.error("该试卷不允许在电脑端考试。");
        return;
      }
      console.log(allowResume);
      // if (allowResume === 2) {
      //   this.$message.error(
      //     "该考试异常退出，需要老师在后台检查重置后才允许恢复考试，请认真阅读考试须知"
      //   );
      //   return;
      // }
      this.$router.push({ path: "/examNeedToKnow", query: { examUserId: id } });
    },
    checkVideo() {
      this.$router.push("/checkVideo2");
    },
    changeFormat(startDate, endDate) {
      const sDate = new Date(startDate);
      const eDate = new Date(endDate);
      const sday = sDate.getDate();
      const eday = eDate.getDate();
      const smonth = sDate.getMonth();
      const emonth = eDate.getMonth();
      let temp = "";
      let str = "";
      if (sday === eday && smonth === emonth) {
        str = sDate.getMonth() + 1 + "月";
        str = str + sDate.getDate() + "日 ";
        temp = sDate.getHours() > 9 ? sDate.getHours() : "0" + sDate.getHours();
        str = str + temp + ":";
        temp =
          sDate.getMinutes() > 9
            ? sDate.getMinutes()
            : "0" + sDate.getMinutes();
        str = str + temp + " ~ ";
        temp = eDate.getHours() > 9 ? eDate.getHours() : "0" + eDate.getHours();
        str = str + temp + ":";
        temp =
          eDate.getMinutes() > 9
            ? eDate.getMinutes()
            : "0" + eDate.getMinutes();
        str = str + temp;
      } else {
        str = sDate.getMonth() + 1 + "月";
        str = str + sDate.getDate() + "日 ";
        temp = sDate.getHours() > 9 ? sDate.getHours() : "0" + sDate.getHours();
        str = str + temp + ":";
        temp =
          sDate.getMinutes() > 9
            ? sDate.getMinutes()
            : "0" + sDate.getMinutes();
        str = str + temp + " ~ ";
        str = str + (eDate.getMonth() + 1) + "月";
        str = str + eDate.getDate() + "日 ";
        temp = eDate.getHours() > 9 ? eDate.getHours() : "0" + eDate.getHours();
        str = str + temp + ":";
        temp =
          eDate.getMinutes() > 9
            ? eDate.getMinutes()
            : "0" + eDate.getMinutes();
        str = str + temp;
      }
      return str;
    }
  }
};
</script>

<style scoped></style>
